(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-equipment-quote"] && !Shopify.designMode) return;
  try {
    
function ccInitQuoteContact(){
document.querySelectorAll('.cc-equipment-quote').forEach(function(section){
if(section.dataset.initialized)return;
section.dataset.initialized='true';
section.querySelectorAll('.cc-equipment-quote__method input').forEach(function(input){
input.addEventListener('change',function(){
const native=section.querySelector('.cc-native-request');
if(native){
const method=native.querySelector('[name="contact[preferred_contact_method]"]');
const phone=native.querySelector('[name="contact[phone]"]');
if(method)method.value=input.value==='phone'?'Phone':'Email';
if(phone){phone.required=input.value==='phone';const mark=phone.parentElement.querySelector('.cc-phone-required');if(mark)mark.hidden=input.value!=='phone';}
}
const active=section.querySelector('.cc-equipment-quote__panel:not([hidden])');
const next=section.querySelector('[data-contact-method="'+input.value+'"]');
if(!next||active===next)return;
const oldRoot=active&&active.querySelector('shopify-forms-embed');
const newRoot=next.querySelector('shopify-forms-embed');
if(oldRoot&&newRoot&&oldRoot.shadowRoot&&newRoot.shadowRoot){
oldRoot.shadowRoot.querySelectorAll('input,textarea').forEach(function(field){
if(!field.name||!field.value||field.type==='hidden'||field.type==='checkbox'||field.type==='radio')return;
const target=Array.from(newRoot.shadowRoot.querySelectorAll('input,textarea')).find(function(other){return other.name===field.name;});
if(!target)return;
const setter=Object.getOwnPropertyDescriptor(target.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:HTMLInputElement.prototype,'value').set;
setter.call(target,field.value);
target.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
target.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
});
}
section.querySelectorAll('.cc-equipment-quote__panel').forEach(function(panel){panel.hidden=panel!==next;});
});
});
});
}
ccInitQuoteContact();
document.addEventListener('shopify:section:load',ccInitQuoteContact);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-equipment-showcase"] && !Shopify.designMode) return;
  try {
    
function ccInitShowcases(){
document.querySelectorAll('.cc-showcase__video').forEach(function(video){
if(video.dataset.initialized)return;
video.dataset.initialized='true';
const source=video.querySelector('source');
let loaded=false;
let interacted=false;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
video.addEventListener('pointerdown',function(){interacted=true;});
video.addEventListener('keydown',function(){interacted=true;});
function loadVideo(){if(loaded)return;source.src=source.dataset.src;video.muted=true;video.load();loaded=true;}
function start(){loadVideo();if(!reduced.matches&&!interacted)video.play().catch(function(){});}
video.addEventListener('click',loadVideo,{once:true});
if('IntersectionObserver' in window){
const observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting)start();else if(loaded)video.pause();});},{rootMargin:'160px 0px',threshold:0.05});
observer.observe(video);
}else{loadVideo();}
});
}
ccInitShowcases();
document.addEventListener('shopify:section:load',ccInitShowcases);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-service-request"] && !Shopify.designMode) return;
  try {
    
const ccObservedRequestRoots=new WeakSet();
function ccApplySharedRequest(){
const section=document.querySelector('.cc-service-request');
if(!section)return false;
const select=section.querySelector('#cc-shared-request-type');
const embed=section.querySelector('shopify-forms-embed');
const root=embed&&embed.shadowRoot;
if(!root)return false;
if(!ccObservedRequestRoots.has(root)){ccObservedRequestRoots.add(root);new MutationObserver(ccApplySharedRequest).observe(root,{childList:true,subtree:true});}
const field=root.querySelector('textarea');
if(!field)return false;
const prefix='Service requested: '+select.value+'\n\n';
if(field.dataset.ccRequestPrefix===prefix)return true;
let text=field.value;
const previous=field.dataset.ccRequestPrefix;
if(previous&&text.startsWith(previous))text=text.slice(previous.length);
const setter=Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value').set;
setter.call(field,prefix+text);
field.dataset.ccRequestPrefix=prefix;
field.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
field.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
return true;
}
function ccChooseSharedRequest(type){
const select=document.getElementById('cc-shared-request-type');
if(select)select.value=type;
ccApplySharedRequest();
}
document.addEventListener('click',function(event){
const link=event.target.closest('a[href="#ContactForm"],a[href="#equipment-quote"]');
if(!link)return;
let type=link.getAttribute('href')==='#equipment-quote'?'Equipment Quote':'Service or Repair';
if(link.classList.contains('cc-priority__request'))type='Priority Response';
if(link.classList.contains('cc-owner__button'))type='Expert Diagnostics';
if(link.classList.contains('cc-maintenance__button'))type='Planned Maintenance';
const details=link.closest('.cc-service-details');
if(details&&details.id==='expert-diagnostics')type='Expert Diagnostics';
if(details&&details.id==='planned-maintenance')type='Planned Maintenance';
if(details&&details.id==='equipment-sales')type='Equipment Quote';
ccChooseSharedRequest(type);
});
document.addEventListener('change',function(event){if(event.target.id==='cc-shared-request-type')ccApplySharedRequest();});
document.addEventListener('shopify:section:load',ccApplySharedRequest);
document.addEventListener('DOMContentLoaded',ccApplySharedRequest);
new MutationObserver(ccApplySharedRequest).observe(document.documentElement,{childList:true,subtree:true});
let ccRequestAttempts=0;
const ccRequestTimer=setInterval(function(){ccRequestAttempts++;if(ccApplySharedRequest()||ccRequestAttempts>=60)clearInterval(ccRequestTimer);},500);
ccApplySharedRequest();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

  
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
